// @flow

import * as R from "ramda";
import { BackButton, Wrapper } from "./Header.styles";
import { LanguageSelect } from "../LanguageSelect";
import { calculateFg } from "./utils";
import { getColor } from "views/resources/theme";
import { useGlobal } from "reactn";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import Icon, { Icons } from "react-hp-icons";
import React, { useDispatch } from "reactn";
import theme from "views/resources/theme";

const Header = ({
	isReservation,
	title,
	bg = theme.colors.primary,
	fixed = false,
	transparent = false,
	styles = {},
	goBack,
	fg,
	icon,
}) => {
	const font_color = fg
		? getColor(fg)({ theme })
		: transparent
		? theme.colors.fg_alt
		: calculateFg(bg);
	const background = transparent ? "transparent" : bg;
	const openDrawer = useDispatch("openDrawer");
	const history = useHistory();
	const { t } = useTranslation(["booking"]);

	const [config] = useGlobal("UIConfig");

	const { hideBackArrow, backArrowpath, hideSideBarIcon } = config;

	const hideBackArrowWithPath =
		hideBackArrow && history.location.pathname === backArrowpath;

	return (
		// $FlowFixMe
		<Wrapper styles={styles} bg={background} fg={font_color} fixed={fixed}>
			<BackButton onClick={goBack}>
				{!hideBackArrowWithPath && (
					<Icon type={Icons.left} color={font_color} size={2.8} />
				)}
				{/*  */}
			</BackButton>
			{title && <h5>{title}</h5>}
			{isReservation && <h5 style={{ fontWeight: 500 }}>{t("book")}</h5>}
			{isReservation && <LanguageSelect />}
			{(!hideSideBarIcon && icon) ||
				(!hideSideBarIcon && (
					<DrawerIcon
						onClick={() => {
							openDrawer();
						}}
						color={font_color}
					/>
				))}
		</Wrapper>
	);
};

const DrawerIcon = ({ onClick, color }) => (
	<div onClick={onClick}>
		<Icon type={Icons.menu} color={color} size={2.8} />
	</div>
);

export const TransparentHeader = ({ goBack }) => (
	<Header goBack={goBack} title="" transparent fixed icon={true} />
);

export const DefaultHeader = ({ goBack, office, isReservation }) => (
	<Header
		isReservation={isReservation}
		goBack={goBack}
		title={officeCategory(office)}
		bg={officeColor(office)}
		fixed
	/>
);

export const NoIcon = () => (
	<div style={{ width: "22px", height: "20px" }}> &nbsp; </div>
);
// $FlowFixMe
const officeColor = (office) => R.pathOr("", ["options", "color"], office);
// $FlowFixMe
const officeCategory = (office) => R.pathOr("", ["category", "name"], office);

export default Header;
